import { DefaultPrizeElement } from '@/components/game/implementations/_default/_domain/models';

export function toNumber(value: string): number {
  const numberValue = parseFloat(value);

  if (isNaN(numberValue)) {
      throw new TypeError(`Cannot convert ${value} to number`);
  }

  return numberValue;
}

export function toNumberArray(value: string, digits: number = 2): number[] {
  const regex = new RegExp(`.{1,${digits}}`, 'g');
  const matches = value.match(regex);

  return (matches === null) ? [] : matches.map(toNumber);
}

export function toBoolean(value: string): boolean {
  if (!/^(?:true|false|True|False)$/.test(value)) {
      throw new TypeError(`Cannot convert ${value} to boolean`);
  }

  return /true|True/.test(value);
}

export function safeCast(value: string, def: string | number | boolean): any {
  if (typeof def === 'string') {
    return (value === undefined ? def : value);
  }

  try {
    if (typeof def === 'number') {
      return value === undefined ? def : toNumber(value);
    } else if (typeof def === 'boolean') {
      return (value === undefined ? def : toBoolean(value));
    }
  } catch (err) {
    return def;
  }
  throw new Error('type cast exception');
}

export function safeBingoCast(value: string): DefaultPrizeElement {
    return (value === undefined) ? { name: '', prize: '' } : { name: '', prize: value };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/helper/cast/safe-cast.ts